import { Injectable } from '@angular/core';
import { AppMetadataStore } from '../app-metadata-store.service';

export function telemetryUuid(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Owns installation storage and runtime identity, independently of authentication and transport. */
@Injectable({ providedIn: 'root' })
export class TelemetryIdentityService {
  readonly appRunId = telemetryUuid();
  installationId?: string;
  availability: 'pending' | 'failed' | 'available' = 'pending';
  readonly ready: Promise<void>;

  constructor(private metadata: AppMetadataStore) {
    this.ready = this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.installationId = await this.metadata.readOrCreateInstallationId(telemetryUuid);
      this.availability = 'available';
    } catch {
      this.availability = 'failed';
    }
  }

}